import axios from 'axios';
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  DocumentSnapshot,
  getDoc,
  getDocs,
  QueryDocumentSnapshot,
  setDoc,
} from 'firebase/firestore';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '..';
import assignTypes from '../services/converter';
import * as cheerio from 'cheerio';
import { Joke, JokeDocument } from '../applicationTypes';
import { async } from '@firebase/util';
import Modal from 'react-modal';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';

//import admin from 'firebase-admin'
export default function JokeType() {
  let { jokeTypeId } = useParams();
  const [jokeDoc, setJokeDoc] = useState<DocumentSnapshot<JokeDocument>>();
  const [subJokes, setSubJokes] = useState<QueryDocumentSnapshot<Joke>[]>();
  const [fetchJokes, setFetchJokes] = useState<string[]>([]);

  const query = collection(db, 'JokesCollection').withConverter(
    assignTypes<JokeDocument>()
  );
  const query2 = collection(
    db,
    `JokesCollection/${jokeTypeId}/Jokes`
  ).withConverter(assignTypes<Joke>());

  const getData = async () => {
    try {
      const docRef = doc(query, jokeTypeId);
      const docSnap = await getDoc(docRef);

      setJokeDoc(docSnap);

      const querySnapshot = await getDocs(query2);

      setSubJokes(querySnapshot.docs);
    } catch (error) {
      console.log(error);
    }
  };
  const addJoke = async (content: string) => {
    try {
      const data: Joke = {
        content,
        rating: 0,
        parentType: jokeDoc?.data()?.type ?? 'joke',
      };

      await addDoc(query2, data);

      const docRef = doc(query, jokeTypeId);
      const querySnapshot = await getDocs(query2);

      await setDoc(docRef, {
        numberOfJokes: querySnapshot.docs.length,
        type: jokeDoc?.data()?.type ?? '',
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async (e: any) => {
    e.preventDefault();

    try {
      const response = await axios.get(e.target[0].value);
      const html = response.data;
      const $ = cheerio.load(html);

      const jokes: string[] = [];
      $(e.target[1].value).each((_idx, el) => {
        jokes.push($(el).text());
      });
      setFetchJokes(jokes);
      return jokes;
    } catch (error) {
      throw error;
    }
  };

  const addJokes = async () => {
    fetchJokes.forEach(async (jokeContent) => {
      await addJoke(jokeContent);
    });
    getData();
    setFetchJokes([]);
  };
  const deleteJoke = async (id: string) => {
    let x = doc(query2, id);
    await deleteDoc(x);
    const docRef = doc(query, jokeTypeId);
    const querySnapshot = await getDocs(query2);

    await setDoc(docRef, {
      numberOfJokes: querySnapshot.docs.length,
      type: jokeDoc?.data()?.type ?? '',
    });
    await getData();
  };

  const deleteFetchedData = (joke: string) => {
    let newArr = fetchJokes.filter((x) => {
      return x != joke;
    });
    setFetchJokes(newArr);
  };

  const addSingleJoke = async (joke: string) => {
    await addJoke(joke);
    deleteFetchedData(joke);
  };

  const addNewSingleJoke = async (e: any) => {
    e.preventDefault();

    try {
      const data: Joke = {
        content: e.target[0].value,
        rating: 0,
        parentType: jokeDoc?.data()?.type ?? 'joke',
      };

      let res1 = await addDoc(query2, data);

      const docRef = doc(query, jokeTypeId);
      const querySnapshot = await getDocs(query2);

      await setDoc(docRef, {
        numberOfJokes: querySnapshot.docs.length,
        type: jokeDoc?.data()?.type ?? '',
      });

      let data2 = {
        to: '/topics/all',
        notification: {
          title: 'نكتة اليوم',
          body: e.target[0].value,
        },
        data: {
          ref: res1.path,
        },
      };
      const response = await fetch('https://fcm.googleapis.com/fcm/send', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Authorization: [
            'key',
            'AAAAn7UwMMI:APA91bG-ub8krW2U3PJpboGZYNIyhTNaddXw3T5muqvv1OxiB5AizpSU1n1jH3uGFlnJ0f3Oe5XmLnZeXYLrH6LSog8xYmV3SUPmw9KoJ25XVAHN03TviBGuUdWHr_HLte0YdwfPFH1o	',
          ].join('='),
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(data2),
      });
      let res = await response.json();
      console.log(res);

      await getData();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [editedJoke, setEditedJoke] =
    useState<QueryDocumentSnapshot<Joke> | null>(null);
  const [isEditModalShown, setIsEditModalShown] = useState(false);
  const editJoke = async (joke: QueryDocumentSnapshot<Joke>) => {
    setEditedJoke(joke);
    setIsEditModalShown(true);
  };

  const editJokeHandler = async (e: any) => {
    e.preventDefault();
    try {
      if (selectedImage && editedJoke) {
        const storage = getStorage();

        const typeRef = ref(
          storage,
          `typeImages/${jokeTypeId}/${editedJoke?.id}`
        );
        await uploadBytes(typeRef, selectedImage);

        let imgUrl = await getDownloadURL(typeRef);

        await setDoc(editedJoke.ref, {
          content: e.target[0].value,
          image: imgUrl,
        });
      }
      setIsEditModalShown(false);
      await getData();
    } catch (error: any) {
      const errorMessage = error.message;
      alert(errorMessage);
    }
  };
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    setSelectedImage(file || null);
  };
  return (
    <div>
      <Modal
        isOpen={isEditModalShown}
        onRequestClose={() => setIsEditModalShown(false)}
        contentLabel='Example Modal'
      >
        <div>
          <input type='file' accept='image/*' onChange={handleImageChange} />
          {selectedImage && (
            <img
              src={URL.createObjectURL(selectedImage)}
              alt='Selected'
              style={{ height: 100, width: 100 }}
            />
          )}
        </div>

        <form
          onSubmit={editJokeHandler}
          className='d-flex flex-col  align-items-center mt-10 border'
        >
          <div className='form-group w-75'>
            <label htmlFor='code' className='h4'>
              محتوى نكتة
            </label>

            <input
              type='query'
              className='form-control'
              defaultValue={editedJoke?.data().content}
            />
          </div>

          <div className='w-50'>
            <button className='btn btn-secondary   m-3'>تعديل النكتة</button>
          </div>
        </form>
      </Modal>
      <div className='h2 mt-3'>{jokeDoc?.data()?.type}</div>

      <div className='d-flex flex-row'>
        <div className='col'>
          <ul>
            {fetchJokes?.map((joke, idx) => {
              return (
                <div className='m-2 border p-2 d-flex flex-col justify-content-between align-items-center'>
                  <li key={idx}>{joke}</li>

                  <button
                    onClick={() => addSingleJoke(joke)}
                    className='btn btn-primary w-50 m-2'
                  >
                    add
                  </button>
                  <button
                    className='btn btn-danger w-50'
                    onClick={() => deleteFetchedData(joke)}
                  >
                    delete
                  </button>
                </div>
              );
            })}
          </ul>
          <form
            onSubmit={fetchData}
            className='d-flex flex-col  align-items-center'
          >
            <div className='form-group w-75'>
              <label htmlFor='code' className='h4'>
                link
              </label>

              <input type='link' className='form-control' />
            </div>
            <div className='form-group w-75'>
              <label htmlFor='code' className='h4'>
                query
              </label>

              <input type='query' className='form-control' />
            </div>
            <div className='w-50'>
              <button className='btn btn-secondary   m-3'>Get data</button>
            </div>
          </form>
          <button onClick={addJokes} className='btn btn-info w-50 '>
            add jokes
          </button>
          {/* <button onClick={sendNotification}>send</button> */}

          <form
            onSubmit={addNewSingleJoke}
            className='d-flex flex-col  align-items-center mt-10 border'
          >
            <div className='form-group w-75'>
              <label htmlFor='code' className='h4'>
                محتوى نكتة
              </label>

              <input type='query' className='form-control' />
            </div>

            <div className='w-50'>
              <button className='btn btn-secondary   m-3'>
                أضف نكتة جديدة
              </button>
            </div>
          </form>
        </div>
        <div className='col'>
          <ul>
            {subJokes?.map((joke) => {
              return (
                <li
                  key={joke.id}
                  className='m-2 border p-2 d-flex flex-row justify-content-between align-items-center'
                >
                  <p>{joke.data().content}</p>

                  <div className='d-flex flex-column'>
                    <div>
                      {joke.data().image && (
                        <img
                          src={joke.data().image}
                          alt='Selected'
                          style={{ height: 100, width: 100 }}
                        />
                      )}
                    </div>
                    <button
                      className='btn btn-danger'
                      onClick={() => deleteJoke(joke.id)}
                    >
                      delete
                    </button>
                    <button
                      className='btn btn-warning'
                      onClick={() => editJoke(joke)}
                    >
                      edit
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
